// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7776) return "static/chunks/477d4af2-e46cc21bf66d5246.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1429":"b291dabb3c221d47","7111":"e9e27f2343f3bf78"}[chunkId] + ".js";
};